/**
 * Why an audience artifact cannot be opened. Lives beside `audienceHref` for the same reason it does: the
 * chat card and the artifacts menu both say this, and two copies drift the moment either is reworded.
 */
export const AUDIENCE_MISSING_ID_REASON = 'This card arrived without an audience id, so there is no page to open.';

/** The in-app route to an audience's detail page — one home so the chat card and the artifacts menu can't drift. */
export function audienceHref(wp: (subpath?: string) => string, audienceId: string): string {
  return wp(`/audiences/${audienceId}`);
}
